import { render, staticRenderFns } from "./PopupBase.vue?vue&type=template&id=5a17b6af&"
import script from "./PopupBase.vue?vue&type=script&lang=js&"
export * from "./PopupBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports